// export const _laborCostHeaders = [
//   { text: "품번", align: "start", value: "no" },
//   { text: "공종", align: "start", value: "name" },
//   { text: "규격", align: "start", value: "type" },
//   { text: "직종", align: "start", value: "occupation" },
//   { text: "공량(M/D)", align: "start", value: "man_per_day" },
//   { text: "할증율", align: "start", value: "surcharge_ratio" },
//   { text: "설계조정률", align: "start", value: "adjustment_ratio" },
//   { text: "공량(M/H)", align: "start", value: "man_per_hour" },
//   { text: "단가(M/D)", align: "start", value: "unit_price" },
//   { text: "수량", align: "start", value: "quantity" },
//   { text: "금액", align: "start", value: "total_amount" },
//   { text: "공정별 금액", align: "start", value: "no_total_amount" },
// ];
export const _laborListHeaders = [
    { text: "품번", align: "center", value: "no" },
    { text: "공종", align: "center", value: "name" },
    { text: "규격", align: "center", value: "type" },
    { text: "직종", align: "center", value: "occupation" },
    { text: "공량(M/D)", align: "center", value: "manHourPerDay" },
    { text: "할증율", align: "center", value: "surchargeRatio" },
    { text: "설계조정률", align: "center", value: "adjustmentRatio" },
    { text: "공량(M/H)", align: "center", value: "manHourPerHour" },
    { text: "단가(M/D)", align: "center", value: "unitPrice" },
    { text: "수량", align: "center", value: "quantity" },
    { text: "금액", align: "center", value: "totalAmount" },
    { text: "행 추가", align: "center", value: "" },
];
export const emptyLaborCosts = {
    no: "",
    name: "",
    type: "",
    occupation: "",
    manPerDay: 0,
    surchargeRatio: 0,
    adjustmentRatio: 0,
    manPerHour: 0,
    unitPrice: 0,
    quantity: 0,
    totalAmount: 0,
    noTotalAmount: 0,
};
